import { Box, Typography } from "@mui/material";
import type { FC } from "react";
import { AiImageResultCard } from "./ai-image-result-card";
import type { ImageResult } from "./ai-tab";

interface AiImageResultsGridProps {
  imageResults: ImageResult[];
  selectedImage: string | null;
  onImageClick: (url: string) => void;
  hasSearched: boolean;
}

export const AiImageResultsGrid: FC<AiImageResultsGridProps> = ({
  imageResults,
  selectedImage,
  onImageClick,
  hasSearched,
}) => {
  const isLoading = imageResults.some((r) => r.loading);
  const validResults = imageResults.filter((r) => r.blobUrl !== null && !r.error);
  const hasResults = validResults.length > 0;
  const allFinishedWithNoResults =
    hasSearched && imageResults.length > 0 && !isLoading && !hasResults;

  return (
    <>
      {hasResults && !isLoading && (
        <Typography variant="overline" color="text.secondary">
          Generated images
        </Typography>
      )}
      <Box
        sx={{
          display: "grid",
          gap: 1.5,
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        }}
      >
        {allFinishedWithNoResults ? (
          <Box
            sx={{
              gridColumn: "1 / -1",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: 4,
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Something went wrong, please try again
            </Typography>
          </Box>
        ) : (
          imageResults.map((result, index) => {
            if (result.error || (!result.loading && !result.blobUrl)) {
              return null;
            }

            return (
              <AiImageResultCard
                key={index}
                id={index}
                blobUrl={result.blobUrl}
                loading={result.loading}
                isSelected={selectedImage === result.blobUrl}
                onClick={onImageClick}
              />
            );
          })
        )}
      </Box>
    </>
  );
};
